export interface Module {
  label: string
  title: string
  body: string
  tagline: string
  color: string
}

export const modules: Module[] = [
  {
    label: '✅ MODULE 1',
    title: 'ENGINE, STARTING & MECHANICAL DIAGNOSTICS',
    body: 'Diagnose the most common engine and starting faults through structured testing. Work through no-start, hard-starting, stalling, rough idle, misfires, compression problems, overheating, loss of power and mechanical fault patterns.',
    tagline: 'Inspect. Test. Isolate.',
    color: '#FF5A1F',
  },
  {
    label: '✅ MODULE 2',
    title: 'FUEL, AIR & INTAKE SYSTEM DIAGNOSTICS',
    body: 'Follow fuel and airflow from delivery to combustion and identify where performance problems begin. Work through fuel pumps, pressure, injectors, carburetors, throttle bodies, vacuum leaks, rich and lean conditions, hesitation and fuel-starvation symptoms.',
    tagline: 'Follow. Compare. Diagnose.',
    color: '#F2760B',
  },
  {
    label: '✅ MODULE 3',
    title: 'ELECTRICAL, BATTERY & CHARGING SYSTEM DIAGNOSTICS',
    body: 'Troubleshoot motorcycle electrical problems using organized testing procedures. Review batteries, starters, stators, regulator/rectifiers, charging faults, relays, fuses, wiring, grounds, voltage drops and parasitic battery drains.',
    tagline: 'Measure. Isolate. Verify.',
    color: '#F2B705',
  },
  {
    label: '✅ MODULE 4',
    title: 'IGNITION, ECU, SENSOR & ELECTRONIC DIAGNOSTICS',
    body: 'Understand ignition and electronic-control faults without replacing components based only on assumptions or fault codes. Work through spark, ignition coils, sensors, ECU circuits, DTCs, reference voltages, electronic inputs and intermittent electronic problems.',
    tagline: 'Read. Test. Confirm.',
    color: '#1478D6',
  },
  {
    label: '✅ MODULE 5',
    title: 'CLUTCH, TRANSMISSION, DRIVETRAIN, BRAKE & CHASSIS DIAGNOSTICS',
    body: 'Identify faults that appear while accelerating, shifting, braking, steering or riding at speed. Diagnose clutch problems, difficult shifting, drivetrain noise, chain faults, brake and ABS issues, wheel bearings, suspension, steering and vibration.',
    tagline: 'Inspect. Compare. Isolate.',
    color: '#1E9E54',
  },
  {
    label: '✅ MODULE 6',
    title: 'COMPLETE MOTORCYCLE FAULT-FINDING WORKFLOWS',
    body: 'Bring symptoms, tests and system information together into one structured diagnostic process. Work through no-starts, misfires, overheating, power loss, charging failures, battery drains, electrical shutdowns, shifting problems, braking faults and intermittent symptoms.',
    tagline: 'Observe. Test. Diagnose.',
    color: '#7B3FD1',
  },
]

export interface Bonus {
  label: string
  title: string
  subtitle: string
  body: string
  tagline: string
}

export const bonuses: Bonus[] = [
  {
    label: '🎁 BONUS 1',
    title: 'MOTORCYCLE SYMPTOM-TO-FAULT QUICK REFERENCE™',
    subtitle: 'Fast Diagnostic Direction From Symptom to System',
    body: 'Start with the motorcycle symptom and quickly identify the systems, priority checks and diagnostic direction that should be considered next.',
    tagline: 'Identify. Prioritize. Diagnose.',
  },
  {
    label: '🎁 BONUS 2',
    title: 'MULTIMETER & ELECTRICAL TESTING FIELD GUIDE™',
    subtitle: 'Practical Motorcycle Electrical Testing Reference',
    body: 'Use structured voltage, resistance, continuity and voltage-drop testing to troubleshoot batteries, charging systems, starters, grounds, wiring and electrical circuits.',
    tagline: 'Measure. Compare. Isolate.',
  },
  {
    label: '🎁 BONUS 3',
    title: 'MOTORCYCLE DTC & SENSOR TROUBLESHOOTING HANDBOOK™',
    subtitle: 'Turn Fault Codes Into a Clear Diagnostic Direction',
    body: 'Use DTCs, sensor information, power, grounds and circuit testing to move from a fault code toward a verified cause instead of replacing parts blindly.',
    tagline: 'Read. Test. Confirm.',
  },
  {
    label: '🎁 BONUS 4',
    title: 'INTERMITTENT FAULT DIAGNOSTIC PLAYBOOK™',
    subtitle: 'Find Motorcycle Faults That Appear and Disappear',
    body: 'Organize heat-related, vibration-related, moisture-related and load-related faults using structured testing and symptom tracking.',
    tagline: 'Reproduce. Monitor. Isolate.',
  },
  {
    label: '🎁 BONUS 5',
    title: 'MOTORCYCLE WORKSHOP DIAGNOSTIC CHECKLIST PACK™',
    subtitle: 'Ready-to-Use Checklists for Organized Fault-Finding',
    body: 'Use practical workshop checklists for no-starts, charging faults, misfires, overheating, electrical problems, drivetrain faults and post-repair verification.',
    tagline: 'Check. Document. Verify.',
  },
]
